module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/186-dominica-7d165d44e0c8dd07b31d22b0dce274fd.svg";